import { render, staticRenderFns } from "./MetadataInputList.vue?vue&type=template&id=a268af36&"
import script from "./MetadataInputList.vue?vue&type=script&lang=js&"
export * from "./MetadataInputList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports